module.exports = __webpack_public_path__ + "img/p-logo.3254e83c.svg";